import { GtfsSchedule } from "./gtfsTypes";
import { TimeData } from "./types";

export default function (time: GtfsSchedule): TimeData[] {
  let computedTimes: TimeData[] = [];
  for (let schedule of Object.values(time.Schedule)) {
    let now = new Date();
    let departureDate = new Date();
    let isLive = false;
    let isCanceled = false;
    let occupancy = null;
    let reliability = ""; //TODO remove ?
    let equipment = null; //TODO remove ?
    let liveType; //TODO remove ?
    if (schedule.canceled) {
      isCanceled = schedule.canceled;
    }
    if (schedule.occupancyPercentage) {
      occupancy = schedule.occupancyPercentage;
    }
    if (schedule.Live) {
      isLive = true;
      let parts = schedule.Live.time.match(/(\d+)/g); // H:i
      if (parts) {
        departureDate.setHours(parseInt(parts[0], 10));
        departureDate.setMinutes(parseInt(parts[1], 10));
        reliability = schedule.Live.reliability;
        equipment = schedule.Live.equipment;
        liveType = schedule.Live.type;
      }
    } else {
      let parts = schedule["DepTime"].match(/(\d+)/g); // d/m/Y H:i
      if (parts) {
        departureDate = new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
          parseInt(parts[3]),
          parseInt(parts[4])
        );
        reliability = "T";
      }
    }
    let minutes = Math.floor(
      (departureDate.getTime() - now.getTime()) / (1000 * 60)
    );
    let restime =
      String(departureDate.getHours()).padStart(2, "0") +
      ":" +
      String(departureDate.getMinutes()).padStart(2, "0");

    let shape = null;
    if (schedule.Shape && schedule.Shape.points) {
      shape = schedule.Shape.points;
    }

    let isTerminus = false;
    let isDeparture = false;
    if (schedule["DepTerm"]) {
      if (schedule["DepTerm"] == "D") {
        isDeparture = true;
      }
      if (schedule["DepTerm"] == "T") {
        isTerminus = true;
      }
    }
    let computedTime: TimeData = new TimeData(isLive, time.DirLib, isCanceled);
    if (schedule.tripHeadsign) {
      computedTime.tripHeadsign = schedule.tripHeadsign;
    }

    computedTime.date = departureDate;
    computedTime.isTerminus = isTerminus;
    computedTime.isDeparture = isDeparture;
    computedTime.minutes = minutes;

    // journeyId can be useful for stories, specially with onStops component
    if (schedule.journeyId) {
      computedTime.journeyId = schedule.journeyId;
    }

    if (reliability) {
      computedTime.reliability = reliability;
    }
    if (liveType) {
      computedTime.type = liveType;
    }
    if (shape) {
      computedTime.shape = shape;
    }
    if (equipment) {
      computedTime.equipment = equipment;
    }
    if (restime) {
      computedTime.time = restime;
    }
    if (occupancy) {
      computedTime.occupancy = occupancy;
    }
    // if (minutes) {
    //   computedTime.minutes = minutes;
    // }
    computedTimes.push(computedTime);
  }
  return computedTimes;
}
